import { DateStr, toDateRange } from '@mi-front/core';
import pick from 'lodash/pick';
import moment from 'moment';
import { apiClient } from '../../../../../../api';
import { useStationsQueryParamParser } from '../../../../../../core/hooks/useStationsQueryParamParser';
import { ReportView } from '../../../../../../core/reports/components/ReportView';
import { useStationsWithAudit } from '../../../../hooks/useStationsWithAudit';
import { ConsecutiveSchedulesReportForm } from './form/form';
import { ConsecutiveSchedulesReportResult } from './result/ConsecutiveSchedulesReportResult';
import { ConsecutiveSchedulesReport, ConsecutiveSchedulesReportFormValues } from './types';

type Props = Record<string, never>;

export function ConsecutiveSchedulesReportView(p: Props) {
  const stations = useStationsWithAudit();

  const defaultConfig: ConsecutiveSchedulesReportFormValues = {
    ...toDateRange(moment().format('YYYY-MM-DD') as DateStr),
    stations: [],
  };

  return (
    <ReportView<ConsecutiveSchedulesReport>
      download={{
        filename: 'consecutive-matches-report',
        local: true,
      }}
      queryParamsTransform={{
        stations: useStationsQueryParamParser(),
      }}
      defaultValues={defaultConfig}
      reportFn={(values) => {
        return apiClient.audit.reportGlobalConsecutiveSchedules<
          ConsecutiveSchedulesReport['Result']
        >({
          ...pick(values, 'from', 'to'),
          stationsIds: (!values.stations.length ? stations : values.stations).map((s) => s.id),
        });
      }}
      Form={ConsecutiveSchedulesReportForm}
      Result={ConsecutiveSchedulesReportResult}
    />
  );
}
